import React, { useEffect, useState } from "react";
import A from "../../Svgs/A"; // The "A" SVG component
import Z from "../../Svgs/Z"; // The "Z" SVG component
import Two from "../../Svgs/2"; // The "2" SVG component
import DesignStudioSVG from "../../Svgs/DesignStudio";
import "../../css/LandingCss.css";

const LandingComponent = () => {
  const [showDesignStudio, setShowDesignStudio] = useState(false); // State to control the visibility of DesignStudioSVG
  const [showCard, setShowCard] = useState(false); // State to control the visibility of the card
  const [closingCard, setClosingCard] = useState(false); // State to track if the card is being closed

  const toggleCard = () => {
    if (showCard) {
      setClosingCard(true); // Trigger the closing animation
      setTimeout(() => {
        setShowCard(false);
        setClosingCard(false); // Reset after animation
      }, 500); // Match the animation duration
    } else {
      setShowCard(true);
    }
  };

  useEffect(() => {
    // Select the SVG paths for A, Z, and 2
    const pathA = document.querySelector(".a-path");
    const pathZ = document.querySelector(".z-path");
    const path2 = document.querySelector(".two-path");
  
    // Ensure the paths exist before proceeding
    if (!pathA || !pathZ || !path2) {
      console.error("SVG paths not found!");
      return;
    }
  
    // Get the total length of the paths
    const lengthA = pathA.getTotalLength();
    const lengthZ = pathZ.getTotalLength();
    const length2 = path2.getTotalLength();
  
    // Reset the styles of each path to prepare for animation
    const resetPath = (path, length) => {
      path.style.strokeDasharray = length;
      path.style.strokeDashoffset = length;
      path.style.fill = "none"; // Start with no fill
      path.style.stroke = "#242424";
      path.style.transition = "none";
    };
  
    resetPath(pathA, lengthA);
    resetPath(pathZ, lengthZ);
    resetPath(path2, length2);
  
    // Trigger reflow to ensure reset styles are applied
    [pathA, pathZ, path2].forEach((path) => void path.getBoundingClientRect());
  
    // Step 1: Animate A and Z simultaneously
    setTimeout(() => {
      pathA.style.transition = "stroke-dashoffset 3s ease";
      pathZ.style.transition = "stroke-dashoffset 3s ease";
      pathA.style.strokeDashoffset = "0"; // Start drawing A
      pathZ.style.strokeDashoffset = "0"; // Start drawing Z
  
      // Fill A and Z after their stroke animation finishes
      setTimeout(() => {
        pathA.style.transition = "fill 1s ease"; // Fill transition
        pathA.style.fill = "#242424"; // Fill with color
  
        pathZ.style.transition = "fill 1s ease"; // Fill transition
        pathZ.style.fill = "#242424"; // Fill with color
      }, 3000); // Wait for stroke animation to complete
    }, 100);
  
    // Step 2: Animate 2 after A and Z finish
    setTimeout(() => {
      path2.style.transition = "stroke-dashoffset 3s ease";
      path2.style.strokeDashoffset = "0"; // Start drawing 2
  
      // Fill 2 after its stroke animation finishes
      setTimeout(() => {
        path2.style.transition = "fill 1s ease"; // Fill transition
        path2.style.fill = "#242424"; // Fill with color
      }, 3000); // Wait for stroke animation to complete
    }, 3100);
  
    // Step 3: Show DesignStudioSVG after all animations
    setTimeout(() => {
      setShowDesignStudio(true);
    }, 6200);
  
    // Cleanup effect: Reset everything when component unmounts or refresh occurs
    return () => {
      resetPath(pathA, lengthA);
      resetPath(pathZ, lengthZ);
      resetPath(path2, length2);
      setShowDesignStudio(false);
    };
  }, []);
  
  
  return (
    <div
      className="svg-container"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        zIndex: 1,
    
       
      }}
    >
      <div className="a-item" style={{ position: "absolute" }}>
        <A />
      </div>
      <div className="z-item" style={{ position: "absolute" }}>
        <Z />
      </div>
      <div className="center-2" style={{ position: "absolute" }}>
        <Two />
      </div>

      {/* Conditionally render DesignStudioSVG */}
      {showDesignStudio && <DesignStudioSVG />}

      {/* Down Arrow to show card */}
     
    </div>
  );
};

export default LandingComponent;

